// extracted by mini-css-extract-plugin
export default {"desktop":"DesktopView_desktop__f0SZT","aside":"DesktopView_aside__KM6+b","page":"DesktopView_page__QQwFL","asideImg":"DesktopView_asideImg__jR5VH"};